<template>
  <div class="tree-main-content">
    <!-- 左侧栏目树 start -->
    <div class="left-box">
      <div class="tree-title">产品分类信息</div>
      <ctree :treeData='treeLevelList' ref='ctree' @clickNode='clickNode' :checkBox='false'></ctree>
    </div>
    <!-- 左侧栏目树 end -->

    <!-- 右侧主体内容 start -->
    <div v-if="currentNode" class="right-box">
      <template>
        <el-tabs v-model="currentPaneName" type="card" @tab-click="clickPane">
          <!------------------ 栏目面板 start --------------->
          <el-tab-pane label="栏目信息" name="paneTree">
            <!-- 按钮菜单 -->
            <div class="tree-menus">
              <div class="searchForm">
                <el-button size="small" type="primary" plain icon="el-icon-edit" @click="editTree(3, null)">当前栏目
                </el-button>
                <el-button size="small" type="success" plain icon="el-icon-plus" @click="editTree(2, null)">新增子栏目
                </el-button>
                <el-button size="small" type="danger" plain icon="el-icon-plus" @click="editTree(1, null)">新增一级
                </el-button>
              </div>
            </div>
            <!-- 子栏目列表 -->
            <div class="tree-list">
              <el-table stripe size="medium" :data="currentChildren" highlight-current-row border
                element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column prop="name" label="子栏目" min-width="150"></el-table-column>
                <el-table-column prop="sort" label="排序" align="center" min-width="80"></el-table-column>
                <el-table-column align="center" prop="showFlag" label="是否显示" min-width="80">
                  <template slot-scope="scope">
                    <el-switch v-model="scope.row.showFlag == 1 ? nshow : fshow" active-color="#13ce66"
                      inactive-color="#ff4949" @change="editShow(scope.$index, scope.row)"></el-switch>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" label="描述" align="center" min-width="100"></el-table-column>
                <el-table-column align="center" label="操作" min-width="140">
                  <template slot-scope="scope">
                    <el-button size="mini" type="success" plain @click="editTree(4, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" plain @click="delTree(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 栏目编辑表单 -->
            <el-dialog title="编辑栏目内容" :visible.sync="editTreeFormVisible" width="40%" @click="closeTreeDialog">
              <el-form label-width="140px" :model="treeFormData" :rules="treeRules" ref="treeFormData">
                <!-- <el-form-item label="父栏目" v-if="(operateType && operateType!=1) && (treeFormData.pid && treeFormData.pid!=0)" prop="parentName"> -->
                <el-form-item label="父栏目">
                  <el-input size="small" style="width:80%" v-model="treeFormData.parentName" disabled
                    class="form-input"></el-input>
                </el-form-item>

                <el-form-item label="名称" prop="name">
                  <el-input size="small" style="width:80%" v-model="treeFormData.name" class="form-input"></el-input>
                </el-form-item>

                <el-form-item label="是否显示" prop="showFlag">
                  <el-select v-model="treeFormData.showFlag" placeholder="选择显示状态">
                    <el-option v-for="item in showFlagList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="上传图片">
                  <el-upload class="avatar-uploader" action="/apiNQ/api/common/upload" :show-file-list="false"
                    :on-success="handleTreeImgSuccess" :before-upload="beforeTreeImgUpload" name="file"
                    :on-progress="onTreeImgProgress">
                    <img v-if="treeFormData.image" :src="treeFormData.image" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
                <el-form-item label="图片路径">
                  <el-input size="small" style="width:80%" v-model="treeFormData.image" class="form-input"></el-input>
                </el-form-item>

                <el-form-item label="排序" prop="sort">
                  <el-input-number size="small" v-model="treeFormData.sort" :min="1" :max="999" label="排序">
                  </el-input-number>
                </el-form-item>

                <el-form-item label="描述信息">
                  <el-input type="textarea" style="width:80%" v-model="treeFormData.remark"></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button size="small" type="primary" @click="submitTreeForm('treeFormData')">提交保存</el-button>
                  <el-button size="small" @click="closeTreeDialog">取消</el-button>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
              </div>
            </el-dialog>
          </el-tab-pane>
          <!------------------ 栏目面板 end ----------------->

          <!------------------ 产品面板 start --------------->
          <el-tab-pane label="产品信息" name="paneItem">
            <!-- 菜单 -->
            <div class="tree-menus">
              <div class="searchForm">
                <el-button size="small" type="success" plain icon="el-icon-plus" @click="editItem(null)">新增配件
                </el-button>
              </div>
            </div>
            <!-- 表格 -->
            <div class="tree-list">
              <el-table stripe size="medium" :data="currentItemList" highlight-current-row border
                element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column prop="sort" label="Grade" align="center" min-width="100"></el-table-column>
                <el-table-column prop="pn" label="PN" align="center" min-width="120"></el-table-column>
                <el-table-column prop="replacePn" label="Replace PN" align="center" min-width="120"></el-table-column>
                <el-table-column prop="name" label="Part Name" align="center" min-width="130"></el-table-column>
                <el-table-column prop="price" label="price" align="center" min-width="100"></el-table-column>
                <el-table-column prop="remark" label="remark" min-width="150"></el-table-column>

                <el-table-column align="center" label="操作" min-width="140">
                  <template slot-scope="scope">
                    <el-button size="mini" type="success" plain @click="editItem(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" plain @click="deleteItem(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 编辑表单 -->
            <el-dialog top="5vh" :title="itemEditTitle" :visible.sync="editItemFormVisible" width="50%"
              @click="closeItemDialog">
              <el-form label-width="240px" :model="itemFormData" :rules="itemRules" ref="itemFormData">

                <el-form-item style="margin-bottom:0px;" label="Grade" prop="sort">
                  <el-input-number size="small" v-model="itemFormData.sort" :min="1" :max="999" label="标号">
                  </el-input-number>
                </el-form-item>

                <el-form-item style="margin-bottom:0px;" label="PN" prop="pn">
                  <el-input size="small" style="width:80%" v-model="itemFormData.pn" class="form-input"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom:0px;" label="Replace PN">
                  <el-input size="small" style="width:80%" v-model="itemFormData.replacePn" class="form-input">
                  </el-input>
                </el-form-item>
                <el-form-item style="margin-bottom:0px;" label="Part Name" prop="name">
                  <el-input size="small" style="width:80%" v-model="itemFormData.name" class="form-input"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom:0px;" label="remark">
                  <el-input type="textarea" style="width:80%" v-model="itemFormData.remark"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom:0px;" label="picture">
                  <!-- <el-upload
                    class="avatar-uploader"
                    action="/apiNQ/api/common/upload"
                    :show-file-list="false"
                    :on-success="handleItemImgSuccess"
                    :before-upload="beforeItemImgUpload"
                    name="file"
                    :on-progress="onItemImgProgress">
                    <img v-if="itemFormData.image" :src="itemFormData.image" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload> -->
                  <el-upload class="upload-demo" action="https://epc.yiec.com/apiNQ/api/common/upload"
                    :before-upload="beforeItemImgUpload" :on-success="handleItemImgSuccess"
                    :on-remove="handleItemRemove" :file-list="itemFormData.pictureList" list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                  </el-upload>
                </el-form-item>

                <el-form-item style="margin-bottom:0px;" label="price">
                  <el-input size="small" style="width:80%" v-model="itemFormData.price" class="form-input"></el-input>
                </el-form-item>


                <el-form-item style="margin-bottom:0px;" label="Unit Qty">
                  <el-input size="small" style="width:80%" v-model="itemFormData.unitqty" class="form-input"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom:0px;" label="HAND">
                  <el-input size="small" style="width:80%" v-model="itemFormData.hand" class="form-input"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom:0px;" label="INTERCHANGE  TYPE">
                  <el-input size="small" style="width:80%" v-model="itemFormData.interchangetype" class="form-input">
                  </el-input>
                </el-form-item>
                <el-form-item style="margin-bottom:0px;" label="Lou's interchange Type">
                  <el-input size="small" style="width:80%" v-model="itemFormData.lousinterchangetype"
                    class="form-input"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom:0px;" label="Replace Luo NO">
                  <el-input size="small" style="width:80%" v-model="itemFormData.replaceluono" class="form-input">
                  </el-input>
                </el-form-item>


                <el-form-item style="margin-bottom:0px;">
                  <el-button size="small" type="primary" @click="submitItemForm('itemFormData')">提交保存</el-button>
                  <el-button size="small" @click="closeItemDialog">取消</el-button>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
              </div>
            </el-dialog>
          </el-tab-pane>
          <!------------------ 产品面板 end ----------------->

        </el-tabs>
      </template>
    </div>
    <div v-else class="right-box">
      <div style="margin:20px;font-size:20px;color:#E6A23C;">
        请选择栏目 !
      </div>
    </div>
    <!-- 右侧主体内容 end -->
  </div>
</template>

<script>
import { user_refresh_token, tree_query_list, tree_level_all, tree_update_show, tree_navs_by_id, tree_by_id, tree_add, tree_update, tree_del, item_list_by_tree, item_add, item_update, item_del } from "../api/api";
import './../assets/css/tree.css';
import ctree from "../components/ctree";

export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭

      timer: null, // 定时器

      showFlagList: [{ value: 1, label: '显示' }, { value: 0, label: '不显示' }],

      // 树层级列表
      treeLevelList: [],

      // 当前选中的元素
      currentPaneName: 'paneTree',
      currentNode: null,
      treeNavs: [], // 当前栏目及其所有的父节点列表 面包屑使用
      currentChildren: [],
      currentItemList: [],

      // 栏目相关操作
      operateType: null, // 1.新增一级栏目 2.添加子栏目 3.修改当前栏目  4.编辑子栏目
      editTreeFormVisible: false,
      treeEditType: null, // 操作类型 1.新增 2.修改
      treeFormData: {
        id: null,
        pid: null,
        name: "",
        sort: 99,
        showFlag: 1,
        remark: "",
        image: "",
        parentName: "" // 冗余字段
      },
      treeRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },

      // 配件相关操作
      editItemFormVisible: false,
      itemEditTitle: "新增配件信息",
      itemEditType: null,
      itemFormData: {
        id: null,
        treeId: null,
        name: "",
        pn: "",
        replacePn: "",
        sort: "",
        price: "",
        pictureList: [],
        remark: "",
        image: "",
        unitqty: "",
        hand: "",
        interchangetype: "",
        lousinterchangetype: "",
        replaceluono: ""
      },
      itemRules: {
        sort: [{ required: true, message: "please type Grade", trigger: "blur" }],
        pn: [{ required: true, message: "please type PN", trigger: "blur" }],
        name: [{ required: true, message: "please type Part Name", trigger: "blur" }]
      },


    };
  },

  // 注册组件
  components: { ctree },

  created() {
    // 定时器 start
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer();
    // 定时器 end

    this.getTreeList();
  },
  destroyed: function () {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
  },

  methods: {
    // 定时器
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.refreshToken()
        }, 10 * 60 * 1000)
      }
    },
    async refreshToken() {
      let param = { "page": "tree", "token": window.localStorage.getItem("user") }
      const data = await user_refresh_token(param);
      window.localStorage.setItem("user", data.data);
    },

    // -----------------左侧树操作 start-----------------
    // 点击树节点,获取当前节点及其子列表
    clickNode(target) {
      // 当前节点
      let tree = this.getTreeById(target.id);
      tree.then(it => {
        this.currentNode = it;
      });

      // 当前节点的子列表 TODO
      this.getChildrenByPid(target.id);
      this.getItemListByTree(target.id);
      this.getTreeNavs(target.id);
    },
    // 获取栏目树列表
    async getTreeList() {
      const data = await tree_level_all({ "appFlag": 0 });
      this.treeLevelList = data.data;
    },
    async getChildrenByPid(pid) {
      let param = { "pid": pid };
      const data = await tree_query_list(param);
      this.currentChildren = data.data;
    },
    // 根据treeId查询实体
    async getTreeById(treeId) {
      const data = await tree_by_id(treeId);
      return data.data;
    },
    // 修改状态
    async editShow(index, data) {
      let showFlag = data.showFlag == 1 ? 0 : 1;
      let param = { "showFlag": showFlag, "id": data.id };
      await tree_update_show(param);
      this.getChildrenByPid(data.pid);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
    },
    // 查询面包屑猎豹
    async getTreeNavs(currentId) {
      const param = {};
      param.id = currentId;
      const data = await tree_navs_by_id(param);
      this.treeNavs = data.data;

      this.$refs.ctree.initData(true, true, true, this.treeNavs.map(item => item.id));
    },
    // -----------------左侧树操作 end-----------------

    // -----------------右侧面板操作 start-----------------
    // 点击面板
    clickPane(tab, event) {
      if (this.currentNode == null) {
        this.$message({
          message: "请选择栏目!",
          type: "warning"
        });
        return;
      }
      console.log(this.currentChildren)
    },
    // 查询产品列表
    async getItemListByTree(treeId) {
      const data = await item_list_by_tree(treeId);
      this.currentItemList = data.data;
    },

    // ---------------------- tree add start---------------------
    // 编辑栏目
    editTree(operateType, rowData) {
      // 判断是否有选中某个节点
      if (this.currentNode == null) {
        alert('请选择栏目!');
        return;
      }
      // 1.新增一级栏目 2.添加子栏目 3.修改当前栏目  4.编辑子栏目
      this.operateType = operateType;
      this.editTreeFormVisible = true;

      this.treeFormData.name = "";
      this.treeFormData.sort = 99;
      this.treeFormData.remark = "";
      this.treeFormData.image = "";
      this.treeFormData.parentName = "";
      this.treeFormData.image = "";
      this.treeFormData.showFlag = 1;

      if (this.operateType == 1) {
        this.treeEditType = 1;
        this.treeFormData.id = null;
        this.treeFormData.pid = 0;
        this.treeFormData.parentName = "根目录";
      }
      if (this.operateType == 2) {
        this.treeEditType = 1;
        this.treeFormData.id = null;
        this.treeFormData.pid = this.currentNode.id;
        this.treeFormData.parentName = this.currentNode.name;
      }
      if (this.operateType == 3) {
        this.treeEditType = 2;
        this.treeFormData.id = this.currentNode.id;
        this.treeFormData.pid = this.currentNode.pid;
        this.treeFormData.name = this.currentNode.name;
        this.treeFormData.remark = this.currentNode.remark;
        this.treeFormData.image = this.currentNode.image;
        this.treeFormData.sort = this.currentNode.sort;
        this.treeFormData.showFlag = this.currentNode.showFlag;
        if (this.currentNode.pid == 0) {
          this.treeFormData.parentName = "根目录";
        } else {
          let tree = this.getTreeById(this.currentNode.pid);
          tree.then(it => {
            this.treeFormData.parentName = it.name;
          })
        }
      }
      if (this.operateType == 4) {
        this.treeEditType = 2;
        this.treeFormData.id = rowData.id;
        this.treeFormData.pid = rowData.pid;
        this.treeFormData.name = rowData.name;
        this.treeFormData.sort = rowData.sort;
        this.treeFormData.remark = rowData.remark;
        this.treeFormData.image = rowData.image;
        this.treeFormData.showFlag = rowData.showFlag;
        let tree = this.getTreeById(rowData.pid);
        tree.then(it => {
          this.treeFormData.parentName = it.name;
        })
      }
    },
    submitTreeForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.treeEditType == 1) {
            this.addTree(this.treeFormData);
          }
          else if (this.treeEditType == 2) {
            this.updateTree(this.treeFormData);
          }
          this.editTreeFormVisible = false;
        } else {
          return false;
        }
      });
    },

    //新增 修改
    async addTree(data) {
      await tree_add(data);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
      this.clearTreeFormData();
      this.getChildrenByPid(this.currentNode.id);
    },
    async updateTree(data) {
      await tree_update(data);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
      this.clearTreeFormData();
      this.getChildrenByPid(this.currentNode.id);
    },

    clearTreeFormData() {
      this.itemFormData.id = null;
      this.itemFormData.treeId = this.currentNode.id;
      this.itemFormData.name = "";
      this.itemFormData.pn = "";
      this.itemFormData.replacePn = "";
      this.itemFormData.sort = "";
      this.itemFormData.price = "";
      this.itemFormData.remark = "";
    },

    // 关闭栏目表单
    closeTreeDialog() {
      this.editTreeFormVisible = false;
    },
    // 上传图片 start
    handleTreeImgSuccess(res, file) {
      URL.createObjectURL(file.raw);
      this.treeFormData.image = res.data
    },
    onTreeImgProgress(proxyReq, req, res) {
      console.log("原路径：" + req.originalUrl, "代理路径：" + req.path)
    },
    beforeTreeImgUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      } else {
        return true;
      }
    },
    // 上传图片 end
    // ---------------------- tree add end---------------------

    // ----------------------tree delete start-------------------
    // 删除配件
    delTree(row) {
      this.delTreeConfirm(row);
    },
    //删除确认对话框
    delTreeConfirm(row) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          tree_del(row.id).then(res => {
            if (res.code === 1) {
              // 刷新页面请求
              this.getChildrenByPid(row.pid)
            } else {
              this.$message({
                type: "success",
                message: "删除失败!"
              });
            }
          });

          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // ----------------------tree delete end---------------------

    // ---------------------- item add start---------------------
    editItem: function (row) {
      if (this.currentNode == null) {
        this.$message({
          message: "请选择栏目!",
          type: "warning"
        });
        return;
      } else {
        this.editItemFormVisible = true;

        if (row != null && row != undefined && row != "undefined") {
          this.itemEditTitle = "修改配件信息";
          this.itemEditType = 2;

          this.itemFormData.id = row.id;
          this.itemFormData.treeId = row.treeId;
          this.itemFormData.name = row.name;
          this.itemFormData.pn = row.pn;
          this.itemFormData.replacePn = row.replacePn;
          this.itemFormData.sort = row.sort;
          this.itemFormData.price = row.price;
          this.itemFormData.remark = row.remark;
          if (row.image == null || row.image == undefined || row.image == "") {
            this.itemFormData.pictureList = [];
          } else {
            this.itemFormData.pictureList = JSON.parse(row.image);
          }

          this.itemFormData.unitqty = row.unitqty;
          this.itemFormData.hand = row.hand;
          this.itemFormData.interchangetype = row.interchangetype;
          this.itemFormData.lousinterchangetype = row.lousinterchangetype;
          this.itemFormData.replaceluono = row.replaceluono;
        } else {
          this.itemEditTitle = "新增配件信息";
          this.itemEditType = 1;

          this.itemFormData.id = null;
          this.itemFormData.treeId = this.currentNode.id;
          this.itemFormData.name = "";
          this.itemFormData.pn = "";
          this.itemFormData.replacePn = "";
          this.itemFormData.sort = "";
          this.itemFormData.price = "";
          this.itemFormData.remark = "";
          this.itemFormData.image = "";
          this.itemFormData.pictureList = [];

          this.itemFormData.unitqty = "";
          this.itemFormData.hand = "";
          this.itemFormData.interchangetype = "";
          this.itemFormData.lousinterchangetype = "";
          this.itemFormData.replaceluono = "";
        }
      }
    },

    submitItemForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // 处理一下图片信息
          this.itemFormData.image = JSON.stringify(this.itemFormData.pictureList);
          if (this.itemEditType == 1) {
            this.addItem(this.itemFormData);
          }
          else if (this.itemEditType == 2) {
            this.updateItem(this.itemFormData);
          }
          this.editItemFormVisible = false;
        } else {
          return false;
        }
      });
    },

    //新增 修改
    async addItem(data) {
      await item_add(data);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
      this.clearItemFormData();
      this.getItemListByTree(this.currentNode.id);
    },
    async updateItem(data) {
      await item_update(data);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
      this.clearItemFormData();
      this.getItemListByTree(this.currentNode.id);
    },

    clearItemFormData() {
      this.itemFormData.id = null;
      this.itemFormData.treeId = this.currentNode.id;
      this.itemFormData.name = "";
      this.itemFormData.pn = "";
      this.itemFormData.replacePn = "";
      this.itemFormData.sort = "";
      this.itemFormData.price = "";
      this.itemFormData.remark = "";
      this.itemFormData.image = "";
      this.itemFormData.pictureList = [];

      this.itemFormData.unitqty = "";
      this.itemFormData.hand = "";
      this.itemFormData.interchangetype = "";
      this.itemFormData.lousinterchangetype = "";
      this.itemFormData.replaceluono = "";
    },
    // 关闭配件表单
    closeItemDialog() {
      this.clearItemFormData();
      this.editItemFormVisible = false;
    },
    // 上传图片 start
    handleItemImgSuccess(res, file) {
      URL.createObjectURL(file.raw);
      let itemInfo = { "name": res.message, "url": res.data };
      this.itemFormData.pictureList.push(itemInfo);
      console.log('item-----')
      console.log(this.itemFormData.pictureList);
    },
    onItemImgProgress(proxyReq, req, res) {
      console.log("原路径：" + req.originalUrl, "代理路径：" + req.path)
    },
    beforeItemImgUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      } else {
        return true;
      }
    },
    handleItemRemove(file) {

      var newarr = [];
      this.itemFormData.pictureList.forEach(function (item) {
        if (item.url != file.url) {
          newarr.push(item)
        }
      })
      this.itemFormData.pictureList = newarr;
    },
    // 上传图片 end

    // ---------------------- item add end-----------------------

    // ----------------------item delete start-------------------
    // 删除配件
    deleteItem(row) {
      this.delItemConfirm(row);
    },
    //删除确认对话框
    delItemConfirm(row) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          item_del(row.id).then(res => {
            if (res.code === 1) {
              // 刷新页面请求
              this.getItemListByTree(row.treeId)
            } else {
              this.$message({
                type: "success",
                message: "删除失败!"
              });
            }
          });

          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // ----------------------item delete end---------------------

    // -----------------右侧面板操作 end-----------------
  }
};
</script>





// WEBPACK FOOTER //
// src/views/Tree.vue